import {focusBlock, getNodeInCodeWorkspace, getPreciseNodeInCodeWorkSpace} from "../highlight";
import {onClick, isDropdownType, onTap} from '../utils';
import event, {EVENTS} from '../../lib/event';
import {getBlockById} from "../blocks";
import {cnMarkToEnMark} from "../../lib/utils";
import Audio from "../../lib/audio";
import Cartoon from '../avatar-action';
import focusElement from "./focus-element";
import clickElement from "./click-element";
import {tipsToCard} from '../steps-runtime';
import {GUIDE_MODE} from '../../lib/constant';

/**
 * @param target
 * @param {string} target.id - 目标的blockId
 * @param {string} target.input - 如果是添加到父块内部，表示内部位置的key
 * @param {number} target.inputIndex - 如果时添加到父块内部，表示内部位置的index
 * @param {string} target.field - 如果是操作的父块fields中的某个参数，表示field的key
 * @param {number} target.fieldIndex - 如果是操作的父块fields中的某个参数，表示field的index
 * @param newValue 新的值
 * @param newValueDisplay 新的显示在界面上的值
 * @param tips
 */
export default function change({target, name, newValue, newValueDisplay, tips}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    return new Promise((resolve, reject) => {
        let node = getPreciseNodeInCodeWorkSpace(target);
        if (!node) {
            reject('target not found: ' + JSON.stringify(target));
            return;
        }
        let block = getBlockById(node.getAttribute('data-id'));
        let argType = node.getAttribute('data-argument-type');
        if (!argType) { //如果当前节点不是参数节点，从子节点中寻找
            let argNode;
            if (name) { //优先通过name查找
                argNode = node.querySelector('[data-argument-type][name="' + name + '"]')
            }
            if (!argNode) { //兼容旧的脚本
                for (let i = 0; i < node.childNodes.length; ++i) {
                    if (node.childNodes[i].getAttribute('data-argument-type') &&
                        (!node.childNodes[i].getAttribute('data-id')  //常规的参数
                            || node.childNodes[i].getAttribute('data-argument-type') === 'variable' //参数里已经放入了变量的情况，可以允许有data-id
                            || (block && block.opcode === 'procedures_call') //自定义积木块的参数，可以运行有data-id
                        )) {
                        argNode = node.childNodes[i];
                    }
                }
            }
            if (!argNode) {
                reject('target not found: ' + JSON.stringify(target));
                return;
            }else {
                node = argNode;
            }
            argType = node.getAttribute('data-argument-type');
        }
        if (!tips) {
            if (isDropdownType(argType)) {
                tips = `点击这里，选择『${newValueDisplay}』`;
            }else if (argType === 'colour') {
                tips = '点击这里，然后点击弹出框底部的『滴管』，然后再点击右上方『舞台』区的要拾取的颜色';
            }else {
                tips = `改为『${newValue}』`;
            }
        }

        if (mode) {
            window.stepsRuntime.insertTips(_index, tips);
        }else {
            Audio.tts(tips);
        }
        if (mode !== GUIDE_MODE) {
            resolve();
            return;
        }
        focusBlock({source: node, tips, reject}, mode, _index);
        if (isDropdownType(argType)) {
            onTap(node, ()=>{
                const handle = () => {
                    const ops = document.querySelectorAll('.blocklyDropDownDiv .goog-menuitem-content');
                    if (ops === null) {
                        setTimeout(handle, 100);
                    } else {
                        for (let i = 0; i < ops.length; ++i) {
                            if (ops[i].innerText.trim() === newValueDisplay) {
                                let lastTop = ops[i].getBoundingClientRect().top;
                                let dropdownNode = document.querySelector('div[role=menu]').parentElement;
                                let dropdownRect = dropdownNode.getBoundingClientRect();
                                //滚动到可见区域
                                if (lastTop < dropdownRect.top) {
                                    dropdownNode.scrollTop += lastTop - dropdownRect.top - 4;
                                }else if (lastTop > dropdownRect.bottom - 20) {
                                    dropdownNode.scrollTop += lastTop - dropdownRect.bottom + 20;
                                }
                                let inter = setInterval(()=>{
                                    if (lastTop == ops[i].getBoundingClientRect().top) {
                                        clearInterval(inter);
                                        focusBlock({source: ops[i].parentElement, reject, zIndex: 2000}, mode, _index);
                                    }
                                    lastTop = ops[i].getBoundingClientRect().top;
                                }, 100)
                                break;
                            }
                        }
                    }
                };
                setTimeout(handle, 100);
            });
        }else if (argType === 'colour') {
            onTap(node, ()=>{
                const handle = () => {
                    const node = document.querySelector('.scratchEyedropper');
                    if (!node) {
                        setTimeout(handle, 100);
                    }else {
                        //focusBlock({source: node, reject, zIndex: 2000});
                        clickElement({element: node, zIndex: 2000, tips: "点击这个滴管，然后在舞台区拾取颜色"});
                    }
                };
                setTimeout(handle, 100);
            });
        }

        const addListener = () => {
            if (isDropdownType(argType)) {
                event.on('change', onChangeFinish);
            }else {
                event.on('change', onChange); //值在变化的过程中会一直回调
                event.on('ui', onUI); //焦点改变的时候回调
                event.on(EVENTS.BG_CLICK, onUI); //背景点击的时候回调
            }

            event.once(EVENTS.STEP_ABORT, onAbort);
        }

        const removeListener = () => {
            if (isDropdownType(argType)) {
                event.off('change', onChangeFinish);
            }else {
                event.off('change', onChange);
                event.off('ui', onUI);
                event.off(EVENTS.BG_CLICK, onUI);
            }
            event.off(EVENTS.STEP_ABORT, onAbort);
        }

        const onAbort = () => {
            reject('Step Abort');
            removeListener();
        }

        let changeEvent;
        const onUI = (e) => {
            if (argType.indexOf("number") > 0 && window._Blockly.FieldTextInput.htmlInput_ && window._Blockly.FieldTextInput.htmlInput_.value){
                onChangeFinish({newValue: window._Blockly.FieldTextInput.htmlInput_.value});
            }else if (changeEvent) { //如果是类似GUI自带的虚拟数字键盘输入，点击背景时，不会触发onChange，这里的changeEvent可能是空的或者旧的
                onChangeFinish(changeEvent);
            }else if (argType === 'colour' && e && e.newValue == null) { //颜色值没有变化
                removeListener();
                event.emit(EVENTS.CLEAR_COVER);
                reject('颜色没有发生变化，请根据提示拾取正确的颜色：' + (newValueDisplay || newValue));
            }
        }
        const onChange = (e) => {
            changeEvent = e;
        }
        const onChangeFinish = async (e) => {
            if (isDropdownType(argType)) { //下拉时，可能会参数一些额外的mutaion的change事件，需要屏蔽掉
                let node = document.querySelectorAll(".blocklyWorkspace")[0].querySelector(`[data-id="${e.blockId}"]`);
                if (e.element === 'field') {
                    let t = document.querySelectorAll(".blocklyWorkspace")[0].querySelector(`[data-id="${e.blockId}"]>g[data-argument-type]:not([data-id])`);
                    if (t) node = t;
                }
                if (!node || !isDropdownType(node.getAttribute('data-argument-type'))) {
                    return;
                }
            }
            removeListener();
            event.emit(EVENTS.CLEAR_COVER);
            let inputValue;
            let block = getBlockById(e.blockId);
            if (block && block.fields) {
                let foundId = false;
                for (let key in block.fields) {
                    if (block.fields[key].id) {
                        foundId = true;
                        break;
                    }
                }
                if (foundId) {
                    await new Promise(resolve => {
                        let count = 0;
                        const intval = setInterval(() => {
                            ++count;
                            if (count > 10) {
                                clearInterval(intval);
                                resolve();
                            }
                            block = getBlockById(e.blockId);
                            for (let key in block.fields) {
                                if (block.fields[key].id === e.newValue) { //列表选中的目标是变量的情况
                                    inputValue = block.fields[key].value;
                                    clearInterval(intval);
                                    resolve();
                                    break;
                                }
                            }
                        }, 100);
                    });
                }

            }
            const isValueEqual = (val1, val2) => {
                if (typeof(val1) === 'string') val1 = val1.trim();
                if (typeof(val2) === 'string') val2 = val2.trim();
                if (typeof(val1) === 'string' && typeof(val2) == 'string') {
                    return cnMarkToEnMark(val1) === cnMarkToEnMark(val2)
                }else {
                    return val1 == val2;
                }
            };
            if (!inputValue) inputValue = e.newValue;
            if (isValueEqual(inputValue, newValue)) {
                resolve(true);
                window._Blockly.WidgetDiv.hide();
                window._Blockly.DropDownDiv.hide();
            }else {
                reject('设置的值『' + inputValue + '』不正确，请将值设置为：' + (newValueDisplay || newValue));
            }
        }
        addListener();
    });
}

